
















import Announcement from './announcement.vue'
import dimensions from 'library/styles/vars/dimensions'

import SsrCarousel from 'vue-ssr-carousel'
import ssrCarouselCss from 'vue-ssr-carousel/index.css'

export default
	components: {
		Announcement
		SsrCarousel
	}

	computed:
		showBanner: -> @$store.getters['globals/showBanner']
		announcements: -> @$store.state.globals.announcementBar?.announcements

	data: ->
		config:
			slidesPerPage: 1
			showArrows: true
			autoplayDelay: 5


